<script>

    import { emailValidator, requiredValidator } from '../utils/validate/validators.js'
    import { createFieldValidator } from '../utils/validate/validation.js'
    import {sendSubcription} from '../utils/subscribe/subscribe.js'

    const [ validity, validate ] = createFieldValidator(requiredValidator(), emailValidator())
    // value input
    let mail = "";
    export let text

    // check valid emails
    function sendEmail(mail) {
        if ($validity.valid && $validity.dirty && mail !== "") {
            sendSubcription(mail)
        }
        else {
            console.log("not valid email")
        }
    }


</script>

<div class="input_div">
    <div>
        <input
                type="email"
            bind:value={mail}
            placeholder={text?.placeholder || "test"}
            use:validate={mail}
            class:field-danger={!$validity.valid && mail !== ""}
            class:field-success={$validity.valid}
        >
            <button class="button-48" on:click={sendEmail(mail)}><span class="text">{text?.buttonSubmitForm}</span></button>
    </div>
    {#if $validity.dirty && !$validity.valid && mail != ""}
<span class="validation-hint">
	 <!--{$validity.message} {$validity.dirty} -->
    {text.errorValidateMessage}
</span>
    {/if}
</div>

<style>

.input_div {
    display:flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    text-align: center;
    max-width: 100%;
    margin: 0 auto;
}

input {
    margin-top: 70px;
}
input:focus{
    outline: none;
}
.button-48 {
    appearance: none;
    background-color: #FFFFFF;
    border-width: 0;
    box-sizing: border-box;
    color: #000000;
    cursor: pointer;
    display: inline-block;
    font-family: Clarkson,Helvetica,sans-serif;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 1em;
    margin: 0;
    opacity: 1;
    outline: 0;
    padding: 1.5em 2.2em;
    position: relative;
    text-align: center;
    text-decoration: none;
    text-rendering: geometricprecision;
    text-transform: uppercase;
    transition: opacity 300ms cubic-bezier(.694, 0, 0.335, 1),background-color 100ms cubic-bezier(.694, 0, 0.335, 1),color 100ms cubic-bezier(.694, 0, 0.335, 1);
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    vertical-align: baseline;
    white-space: nowrap;
}

.button-48:before {
    animation: opacityFallbackOut .5s step-end forwards;
    backface-visibility: hidden;
    background-color: #EBEBEB;
    clip-path: polygon(-1% 0, 0 0, -25% 100%, -1% 100%);
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    transform: translateZ(0);
    transition: clip-path .5s cubic-bezier(.165, 0.84, 0.44, 1), -webkit-clip-path .5s cubic-bezier(.165, 0.84, 0.44, 1);
    width: 100%;
}

.button-48:hover:before {
    animation: opacityFallbackIn 0s step-start forwards;
    clip-path: polygon(0 0, 101% 0, 101% 101%, 0 101%);
}

.button-48:after {
    background-color: #FFFFFF;
}

.button-48:active {
    background-color: #333333;
}

.button-48 span {
    z-index: 1;
    position: relative;
}
.field-danger {
    border-color: red;
}

.field-success {
    border-color: green;
}
</style>